import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

import { calculateBreakpointWidth } from '../../../../utils/helper/calculateBreakpointWidth'
import i18n from '../../../../utils/i18n'
import { LocalMarkdown } from '../../../markdownReader/LocalMarkdown'
import { RemoteMarkdown } from '../../../markdownReader/RemoteMarkdown'

type Props = {
  visible: boolean
  setVisible: any
  header: string | null
  filename: string | null
  isLocalfile?: boolean | false
}

export const FooterDialog: React.FC<Props> = ({
  visible,
  setVisible,
  header,
  filename,
  isLocalfile,
}) => {
  const { t } = useTranslation()
  const filenameWithoutExtension =
    filename && filename.substring(0, filename.indexOf('.'))
  const extension =
    filename && filename.substring(filename.indexOf('.'), filename.length)
  const translatedFilename =
    filenameWithoutExtension + '-' + i18n.language + extension

  const footer = (
    <div className="mt-3">
      <Button
        label={t('login.content.footer.dialogCloseButton')}
        icon="pi pi-check"
        onClick={() => setVisible(false)}
        autoFocus
      />
    </div>
  )

  return (
    <Dialog
      header={header}
      visible={visible}
      footer={footer}
      onHide={() => setVisible(false)}
      style={{ width: '60rem' }}
      breakpoints={{ [calculateBreakpointWidth(60)]: '90vw' }}
      draggable={false}
      dismissableMask={true}
      blockScroll
    >
      {isLocalfile ? (
        <LocalMarkdown filename={translatedFilename} />
      ) : (
        <RemoteMarkdown filename={translatedFilename} />
      )}
    </Dialog>
  )
}
